import { render, staticRenderFns } from "./keyProject.vue?vue&type=template&id=2b25dc72"
import script from "./keyProject.vue?vue&type=script&lang=js"
export * from "./keyProject.vue?vue&type=script&lang=js"
import style0 from "./keyProject.vue?vue&type=style&index=0&id=2b25dc72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports